// imports
import $ from "jquery";
import { Loader } from "./loader";
import { MostVisitedService } from "../services/mostVisitedService";
import { ILinkItem, IVisitedLinkItem } from "../dto/ILinkItem";
import { handleHideSideBarSubLevel } from "./sidebar";

// globals
const service = new MostVisitedService();
let mostVisited: ILinkItem[];

export function initialize(): void {
  // $(".js-load-mostvisited").on("aria-pressed", onShowMostVisited);
  $(".js-load-mostvisited").on("click", onShowMostVisited);
  $("#most-visited-close-button").on("click", () =>
    handleHideSideBarSubLevel("js-load-mostvisited")
  );
  triggerAddVisited();
}

const triggerAddVisited = () => {
  const contentId = (window as any).contentId;
  contentId && service.addVisited(contentId);
};

function onShowMostVisited(event: any, params: any): void {
  $('.sidebar').addClass('sidebar--sub-level');
  $(".subNavigation").addClass("selected--mostvisited");
  $(".pIRecentlyRead").addClass("selectedItem");
  $("#mylatestvisited_sidebar").addClass("selectedItem").focus();
  
  $(".pIFavorites").hide();
  $(".pIUser").hide();
  $(".pINotes").hide();
  $(".pIWatched").hide();

  $("#mynotes_sidebar").removeClass("selectedItem");
  $("#myfavorites_sidebar").removeClass("selectedItem");
  $("#mycoverage_sidebar").removeClass("selectedItem");

  loadData();
  
}

function loadData(): void {
  const $container = $("#sidebar-mostvisited");
  const $noContentMsg = $container.find(".js-no-content-msg:first");
  const $loader = Loader.create();

  $noContentMsg.replaceWith($loader);

  service.getMostVisited(
    (data) => {
      mostVisited = data;

      if (!data.length) {
        $loader.replaceWith($noContentMsg);
        return;
      }
      populateData(data, $container, $loader);
    },
    () => {
      $loader.replaceWith($noContentMsg);
      alert("Tillfälligt fel: Kan inte hämta senast lästa");
    }
  );
}

function populateData(data: any, $container: any, $loader: any): void {
  const $wrapper = generateWrapper();

  for (let i = 0; i < data.length; i++) {
    if(i < 10){
      const $item = generateItem(data[i]);
      $wrapper.append($item);
    }
  }

  $loader.replaceWith($wrapper);
}

export function formatDate(input: string): string {
  const inputDate = new Date(input);
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);

  if (isToday(inputDate)) {
      return "IDAG";
  } else if (isYesterday(inputDate)) {
      return "IGÅR";
  } else {
      const options = { day: "numeric", month: "short" };
      const formattedDate = inputDate.toLocaleDateString("sv-SE", options)
                                      .toLowerCase()
                                      .split(' ')
                                      .map(part => part.slice(0, 3))
                                      .join(' ');
      return formattedDate;
  }
}

function isToday(date: Date): boolean {
  const today = new Date();
  return date.getDate() === today.getDate() &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear();
}

function isYesterday(date: Date): boolean {
  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);
  return date.getDate() === yesterday.getDate() &&
      date.getMonth() === yesterday.getMonth() &&
      date.getFullYear() === yesterday.getFullYear();
}



function generateWrapper(): any {
  return $(
    `<ol class="notifications__notifications-list  notifications__notifications-list--new-notices"></ol>`
  );
}

function generateItem(item: IVisitedLinkItem): any {
  return $(`
        <li>
            <a class="notifications__notifications-item lv a" href="${item.linkItem.url}">
              <div class="top">
                ${item.documentMetaType ? (
                `<span class="tag">${item.documentMetaType}</span>`
                ) : ''}
                ${item.lastVisitedDate ? (
                  `<span class="date">${formatDate(item.lastVisitedDate)}</div>`
                ) : ''}
              </div>
              <div class="bottom">
                <span class="notifications__link-item">${item.linkItem.text}</span>
              </div>
            </a>
        </li>
    `);
}

